import { createControlFn } from "../create-control-fn"

const filterInvalidAddressCharacters = (value: any) =>
  /^[a-zA-Zàáèéìíòóùú0-9 /']*$/.test(value)

const filterInvalidForeignAddressCharacters = (value: any) =>
  /^[a-zA-Zàáèéìíòóùú0-9 ./'-]*$/.test(value)

const controlAddressFieldFn = createControlFn({
  filterValueCb: filterInvalidAddressCharacters,
})
const controlForeignAddressFieldFn = createControlFn({
  filterValueCb: filterInvalidForeignAddressCharacters,
})

export { controlAddressFieldFn, controlForeignAddressFieldFn }
